
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "PageHeader",
  data() {
    return {
      translation: {
        msg1: this.$t("sorrypage nouknow"),
        msg2: this.$t("sorrypage welcome to nouknow"),
        msg3: this.$t("sorrypage brain health performance self check"),
      },
    };
  },
  computed: {
    logo() {
      return `${this.$baseURL}img/i18n/${this.languageCode}/logo.svg`;
    },
    welcome() {
      return `${this.$baseURL}img/i18n/${this.languageCode}/sp/ttl-welcome.png`;
    },
    content() {
      return `${this.$baseURL}img/i18n/${this.languageCode}/sp/ttl-content.png`;
    },
    ...mapState(["languageCode"]),
  },
});
